module.exports = __webpack_public_path__ + "img/question-solid.326c5d92.svg";